import { TrackingEvent } from '@caresend/types';
import update from 'immutability-helper';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../inputs/Checkbox.vue.js';
import { usePortalStore } from '../portal/store/portal/index.js';
import { getChartingItemByIndexArray, getUpdatedChartingItems } from '../portal/store/portal/helpers/charting.js';
import { trackEvent } from '../../../functions/tracking/tracking.js';
import { getStore } from '../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'ChartingChecklistItemCard',
    components: {
        Checkbox: __vue_component__,
    },
    props: {
        procedureID: {
            type: String,
            required: true,
        },
        chartingItemIndexArray: {
            type: Array,
            required: true,
        },
        checkboxIndex: {
            type: Number,
            default: undefined,
        },
        checklistItemIndex: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const store = getStore();
        const { procedures } = usePortalStore();
        const item = computed(() => procedures.getters.getChartingChecklistItem(props.procedureID, props.chartingItemIndexArray, props.checkboxIndex));
        const setCheckedValue = (value) => {
            var _a;
            if (!item.value)
                return;
            const newChartingChecklistItem = {
                checked: value,
            };
            if (item.value.highlight) {
                newChartingChecklistItem.highlight = false;
            }
            trackEvent(store, TrackingEvent.SET_CHARTING_CHECKBOX, {
                procedureID: props.procedureID,
                label: item.value.label,
            });
            /** Following logic was ported and adapted from legacy nurse app 'portal/SET_CHARTING_ITEM' */
            const procedure = procedures.getRaw(props.procedureID);
            const chartingItems = (_a = procedure === null || procedure === void 0 ? void 0 : procedure.charting) === null || _a === void 0 ? void 0 : _a.items;
            const chartingItem = getChartingItemByIndexArray(chartingItems, props.chartingItemIndexArray);
            let newPartialItem = {};
            const { checklistItemIndex } = props;
            if (newChartingChecklistItem
                && checklistItemIndex !== undefined
                && chartingItem) {
                newPartialItem = update(chartingItem, {
                    checklist: {
                        [checklistItemIndex]: {
                            $merge: newChartingChecklistItem,
                        },
                    },
                });
            }
            else if (newChartingChecklistItem) {
                newPartialItem = newChartingChecklistItem;
            }
            const newItems = getUpdatedChartingItems(chartingItems !== null && chartingItems !== void 0 ? chartingItems : [], props.chartingItemIndexArray, newPartialItem);
            procedures.setChildOf(props.procedureID, 'charting/items', newItems, true);
        };
        return {
            setCheckedValue,
            item,
        };
    },
});

export { script as default };
